import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TextareaCount.css';

class TextareaCount extends Component {
  constructor(props) {
    super(props);
    this.state = {
            length: 0,
            value: ''
        }    
    }

    handleKeyUp = (e) => {
        if(e.target.value.length > this.props.maxLength){
            e.target.value = e.target.value.slice(0, this.props.maxLength);
            e.preventDefault();
            e.stopPropagation();
        } else {
            this.setState({
                length: e.target.value.length,
                value: e.target.value
            });
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.value && nextProps.value.length > 0){
            let length = {...this.state.length};
            length = nextProps.value.length;
            this.setState({ length });
        }
    }
    
    render() {
        return (
            <div>
                <div className="showtix-form__input">
                    <textarea 
                        className="showtix-input" 
                        rows="5" 
                        id={this.props.id}
                        object={this.props.object}
                        name={this.props.name}
                        onKeyUp={this.handleKeyUp} 
                        onChange={this.props.handleChange}
                        value={this.props.value}
                    >
                    </textarea>
                </div>
                <div className="showtix-note text-right">
                    {this.state.length}/{this.props.maxLength}
                </div>
            </div>
        );
    }
}

TextareaCount.propTypes = {
    maxLength: PropTypes.string,
    object: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    handleChange: PropTypes.func
}

export default TextareaCount;


// WEBPACK FOOTER //
// ./src/components/Common/TextareaCount/TextareaCount.js